import api from './api';

/** Tipo de pessoa de um fluxo do balcão — e dos serviços da esteira dele. */
export type PersonType = 'PF' | 'PJ';

type GetCompanyServicesResponse = {
  cos_ser_id: number;
  ser_name: string;
  ser_description: string;
  ser_pubsub: string;
  ser_additional_fields: boolean;
  /** 1 quando o serviço consome foto (biometria facial). */
  ser_send_selfie: number;
}[];

/**
 * Serviços de esteira contratados pela empresa, do tipo de pessoa pedido
 * (`GET /services?tipo=PF|PJ`).
 */
export async function getCompanyServices(
  signal: AbortSignal,
  tipo: PersonType = 'PF',
): Promise<GetCompanyServicesResponse> {
  // Requisição cancelada (troca de tipo de pessoa, tela desmontada) não tem
  // `response`: volta lista vazia em vez de estourar na desestruturação.
  const response = await api
    .get('/services', { signal, params: { tipo } })
    .then(res => res)
    .catch(err => err.response);

  return Array.isArray(response?.data) ? response.data : [];
}
